import React from "react";
import { Box, Typography } from "@mui/material";
import { textPrimary, textSecondary, font, statTileSx } from "./schoolPortalTheme";

// Small summary card used above roster tables — e.g. "12 Total", "9 Active".
// Deliberately roster-derived counts only (no activity/accuracy data), so it's
// safe to show even on a Module 1-only (Learn) account.
// `trend` is optional — a direction ("up"/"down"/"flat") is a real signal a
// point-in-time count can't show (e.g. "68% active, down from 81%"); omit it
// for tiles that don't have a prior-period comparison.
export default function StatTile({ icon, label, value, color, trend }) {
  return (
    <Box sx={statTileSx}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box sx={{
          width: 38, height: 38, borderRadius: "10px", flexShrink: 0,
          backgroundColor: `${color}14`, display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          {React.cloneElement(icon, { sx: { color, fontSize: 19 } })}
        </Box>
        <Box>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 800, color: textPrimary, fontFamily: font, lineHeight: 1.1 }}>
              {value}
            </Typography>
            {trend}
          </Box>
          <Typography sx={{ fontSize: "12px", color: textSecondary, fontFamily: font, mt: 0.25 }}>
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
